module.exports = __webpack_public_path__ + "static/media/RR-VP-1.18a55ef4.png";